// extracted by mini-css-extract-plugin
export default {"productsItemTitle":"zoU2","productsItemDivider":"G9OE","customDoneIcon":"P2LY","postsComponent":"hsBK","productsFeatured":"_6W2E","labelBox":"usHd","cardImage":"mnZ0"};